import { Taxonomy } from "library/types";
import {
  ByCodeStateByTaxonomy,
  ByIdStateByTaxonomy,
  TaxonomyTaxonomyState,
} from "library/types/types_old";
import React, { useMemo } from "react";
import { useGetTaxonomies } from "state/queries/useGetTaxonomies";

export const useTaxonomy = (): TaxonomyTaxonomyState => {
  const { data: taxonomy } = useGetTaxonomies();

  const retVal = useMemo(() => {
    if (!taxonomy) return {} as TaxonomyTaxonomyState;

    const result: any = {};
    Object.entries(taxonomy).forEach(([key, taxonomyGroup]) => {
      const taxonomyStateByTaxonomy = {
        byId: taxonomyGroup.reduce((byId: any, t: any) => {
          byId[t.id] = t;
          return byId;
        }, {} as ByIdStateByTaxonomy),
        byCode: taxonomyGroup.reduce((byCode: any, t: any) => {
          byCode[t.code] = t;
          return byCode;
        }, {} as ByCodeStateByTaxonomy),
        items: taxonomyGroup,
      };
      result[key] = taxonomyStateByTaxonomy;
    });
    return result;
  }, [taxonomy]);

  return retVal;
};
